<ng-container *ngIf="!!page">
    <tt-card>
        <tt-input ttLabel="transportarea_move_from_name" [(ttModel)]="page.transportarea_move_from_name" ttReadonly></tt-input>
        <tt-select ttLabel="transportarea_move_to" [(ttModel)]="page.transportarea_move_to_keyno" [ttData]="transportAreas"></tt-select>
        <tt-button-save ttText="transportareappadd_move" ttIcon="fas fa-exchange" (ttClick)="move()" [ttDisabled]="movingDisabled" [ttLoading]="moving"></tt-button-save>
    </tt-card>
</ng-container>
